import axios from 'axios'

/**
 * unite49 香港六合彩历史开奖接口
 * GET https://h5.49217005.com:8443/unite49/h5/lottery/search
 * https://49208.com/unite49/h5/lottery
 * 参数: pageNum, lotteryType=1, year, sort=1
 *
 * 开发环境走 vue.config.js 代理 /hk-history 以绕过 CORS
 */
const USE_PROXY =
  typeof process !== 'undefined' &&
  process.env &&
  process.env.NODE_ENV === 'development'

const BASE = USE_PROXY
  ? '/hk-history'
  : 'https://49208.com'

const client = axios.create({
  timeout: 25000,
  headers: { Accept: 'application/json' }
})

/**
 * @param {{ pageNum?: number, year?: number, sort?: number }} params
 */
export function fetchHkHistory({ pageNum = 1, year, sort = 1 } = {}) {
  const y = year != null ? year : new Date().getFullYear()
  return client.get(`${BASE}/unite49/h5/lottery/search`, {
    params: { pageNum, lotteryType: 1, year: y, sort }
  })
}
